import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { boardCells, boardSize } from "../features/hex/board";
import { HexBoard } from "../features/hex/HexBoard";
import { useCanvasState } from "../lib/useCanvasState";
import { useTransparentCanvas } from "../lib/useTransparentCanvas";

/** The agent canvas: transparent, faint, and stacked over the capture in OBS. */
export const Route = createFileRoute("/hex/display/$choiceMount/$boardMount")({
  component: DisplayCanvas,
});

function DisplayCanvas() {
  const { choiceMount, boardMount } = Route.useParams();
  useTransparentCanvas();
  const choices = useCanvasState(choiceMount);
  const game = useCanvasState(boardMount);

  const cells = boardCells(choices.state, game.state);
  const { columns, rows } = boardSize([
    ...(choices.state?.entities ?? []),
    ...(game.state?.entities ?? []),
  ]);

  // Never on the canvas, because this one is on air. The console is where a browser source says
  // why it is blank, and a blank broadcast with no explanation anywhere is the worse failure.
  const problem = choices.error ?? game.error;
  useEffect(() => {
    if (problem !== null) console.warn(`[canvas] cannot read this run: ${problem}`);
  }, [problem]);

  if (columns === 0) return <main style={{ position: "fixed", inset: 0 }} />;

  return (
    <main style={{ position: "fixed", inset: 0, background: "transparent" }}>
      <HexBoard columns={columns} rows={rows} cells={cells} look="broadcast" />
    </main>
  );
}
